import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';

// app
import { quoteBindAxios } from 'lib/quoteBind';
import { QB_RISK_DETAILS, QB_RISK_QUOTES } from 'lib/quoteBind/queryKeys';
import { enqueueNotification } from 'stores';
import * as utils from 'utils';
import { logoutAuth0 } from 'utils/auth0/auth0';

// risks
export const useRequestDismissIssue = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const handleError = (err) => {
    const errorParams = {
      file: 'quoteBind.mutations.useRequestDismissIssue',
    };

    dispatch(enqueueNotification('notification.requestDismissIssues.fail', 'error'));

    utils.api.handleError(err, errorParams);
    utils.api.handleUnauthorized(err, null, logoutAuth0);
  };

  const handleSuccess = (res) => {
    queryClient.invalidateQueries(QB_RISK_DETAILS, { id: res.riskId });
    queryClient.invalidateQueries([QB_RISK_QUOTES, { id: res.riskId }]);

    dispatch(enqueueNotification('notification.requestDismissIssues.success', 'success'));
  };

  return useMutation(
    async ({ quoteId }) => {
      if (!quoteId) {
        throw new Error('Invalid data');
      }

      const result = await quoteBindAxios.put(`/quotes/${quoteId}/request-to-dismiss-issues`);
      return result?.data;
    },
    {
      onSuccess: (res) => handleSuccess(res),
      onError: (err) => handleError(err),
      keepPreviousData: true,
    }
  );
};
